import { FC, useMemo } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { ShareWishlistItem } from './ShareWishlistItem'
import { Button } from '@corratech/pylot-ui'
import useIsMobile from '@lib/hooks/useIsMobile'
import { useUI, ToastType } from '@corratech/pylot-ui/context'
import { useAddToCart } from '@pylot-data/hooks/cartManager/use-add-to-cart'
import { cartUpdateEvent } from '@lib/utils/exponeaTrackingEvents'
import { WishlistSharedItems } from '@pylot-data/pylotschema'

import s from '@pagestyles/Wishlist.module.scss'

export type SharedWishlistItemsProps = {
    items: WishlistSharedItems[]
}

const TIMEOUT_AFTER_OPENING_SIDEBAR = 100

export const ShareWishlistItemGrid: FC<SharedWishlistItemsProps> = ({
    items
}) => {
    const { t } = useTranslation(['wishlist', 'common'])
    const { addToCart, isAdding } = useAddToCart()
    const isMobile = useIsMobile()
    const { openToast, openSidebar, openCartToast } = useUI()

    const itemGrid = useMemo(() => {
        return items?.map((item, key) => (
            <ShareWishlistItem item={item} key={key} />
        ))
    }, [items])

    const addProductsHandler = async () => {
        const totalProducts = items.map((item) => {
            return {
                sku: item.product.sku,
                uid: `${item.product.id}`,
                quantity: 1
            }
        })

        const response = await addToCart([...totalProducts], [])

        const errorMessage =
            response?.errors?.[0]?.message ??
            response?.user_errors?.[0]?.message ??
            null

        const successMessage = t('wishlist|The products has been added to cart')

        if (!isMobile) {
            openSidebar()
        }

        if (response?.data && !errorMessage) {
            const { cart } = response.data

            items.map((item) => {
                const addedProduct = {
                    ...item,
                    sku: item.product.sku,
                    uid: item.product.id,
                    price_range: item.product.price_range
                }
                cartUpdateEvent('add', addedProduct, cart)
            })
        }
        setTimeout(
            () =>
                isMobile
                    ? openToast(
                          errorMessage ? errorMessage : successMessage,
                          errorMessage ? ToastType.Warning : ToastType.Success,
                          true
                      )
                    : openCartToast(
                          errorMessage ? errorMessage : successMessage,
                          errorMessage ? ToastType.Warning : ToastType.Success
                      ),
            TIMEOUT_AFTER_OPENING_SIDEBAR
        )
    }

    return (
        <div>
            <div className={s['wishlist-shared-header']}>
                <div>{t('producto')}</div>
                <div>{t('precio')}</div>
                <div>{t('wishlist|Add to cart')}</div>
            </div>
            <div className={s['wishlist-shared-container']}>{itemGrid}</div>
            <div className={s['wishlist-shared-action']}>
                <Button
                    aria-label={t('Add to Cart')}
                    type="button"
                    // className={s['wishlist-shared-action']}
                    onClick={() => addProductsHandler()}
                    loading={isAdding}
                    disabled={isAdding}
                >
                    {t('wishlist|Add All cart')}
                </Button>
            </div>
        </div>
    )
}
